import { Button } from "~/shadcn/ui/button"
import { FilterLabel } from "~/ui/FilterLabel"
import { Hr } from "~/ui/Hr"
import { ModalDialog } from "~/ui/ModalDialog"
import { H2 } from "~/ui/typography"
import { AgencyFilter } from "./AgencyFilter"
import { CategoryFilter } from "./CategoryFilter"
import { AllFiltersCountryFilter } from "./CountryFilter"
import { ExclusivityFilter } from "./ExclusivityFilter"
import { GenderFilter } from "./GenderFilter"
import { InstagramFilter } from "./InstagramFilter"
import { TagFilter } from "./TagFilter"
import { TikTokFilter } from "./TikTokFilter"
import { YoutubeFilter } from "./YoutubeFilter"

export const AllFiltersModal = ({
  open,
  setOpen,
  onClear,
  onSubmit,
  showAgencyFilter = false,
}: {
  open: boolean
  setOpen: (open: boolean) => void
  onClear: () => void
  onSubmit: () => void
  showAgencyFilter?: boolean
}) => {
  return (
    <ModalDialog open={open} onClose={() => setOpen(false)}>
      <div className="absolute top-0 bottom-0 left-0 right-0 flex flex-shrink flex-col">
        <div className="flex-grow p-6 overflow-y-auto">
          <H2>All Filters</H2>
          {showAgencyFilter && (
            <>
              <AgencyFilter />
              <Hr className="mt-6 mb-4" />
            </>
          )}
          <FilterLabel text="Platform" className="mb-0" />
          <TikTokFilter />
          <InstagramFilter />
          <YoutubeFilter />
          <Hr className="mt-6 mb-4" />
          <CategoryFilter />
          <Hr className="mt-6 mb-4" />
          <TagFilter />
          <Hr className="mt-6 mb-4" />
          <FilterLabel text="Country" className="mb-0" />
          <div className="flex flex-row items-stretch gap-2">
            <AllFiltersCountryFilter name="countryCodes" label="Influencer" />
          </div>
          <Hr className="mt-6 mb-4" />
          <FilterLabel text="Gender" className="mb-0" />
          <div className="flex flex-row items-stretch gap-2">
            <GenderFilter />
          </div>
          <Hr className="mt-6 mb-4" />
          <ExclusivityFilter />
        </div>
        <div className="p-6 pt-0">
          <Hr />
          <div className="flex flex-row justify-between pt-3">
            <Button
              type="button"
              onClick={onClear}
              size="none"
              variant="linkSecondary"
            >
              Clear All
            </Button>
            <Button type="submit" onClick={onSubmit}>
              Apply Filters
            </Button>
          </div>
        </div>
      </div>
    </ModalDialog>
  )
}
